// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5120":"css/admin-app.6898","9803":"css/app.6898"}[chunkId] + ".css";
};